// 在 src/components 中创建一个新文件 QueryPreservingRoute.tsx
import React from 'react';
import {Route, useLocation} from 'react-router-dom';

const QueryPreservingRoute = ({
  component: Component,
  render,
  ...rest
}: {
  component?: React.ComponentType<any>;
  render?: (props: any) => React.ReactNode;
  [key: string]: any;
}) => {
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={(props) => {
        // 将当前查询字符串传递给组件
        const routeProps = {...props, preservedQuery: location.search};

        if (Component) {
          return <Component {...routeProps} />;
        }

        if (render) {
          return render(routeProps);
        }

        return null;
      }}
    />
  );
};

export default QueryPreservingRoute;
